import React, { useContext } from "react";
import { Route } from "react-router-dom";
import { LazyRouteConfigItem } from "./interface";
import RouteConfigContext from "./context";
// import PageLoading from "reactPath/views/components/pageLoading/loading";

export const LoaderRouteComponent = ({
  component: Component,
  ...props
}: {
  component: LazyRouteConfigItem["component"];
}) => {
  if (!Component) return null;
  return (
    <React.Suspense fallback={<div />}>
      <Component {...props} />
    </React.Suspense>
  );
};

export const LazyRoute = ({
  component: Component,
  children,
  ...props
}: LazyRouteConfigItem) => {
  const { rootPath } = useContext(RouteConfigContext);
  if (children?.length) {
    return (
      <>
        {children.map((child) => (
          <LazyRoute
            key={`${props.path}${child.path}`}
            {...child}
            path={`${props.path}${child.path}`}
          />
        ))}
      </>
    );
  }
  if (!Component) return null;
  const finalPath = `${rootPath}${props.path}`;
  return (
    <Route
      exact
      path={finalPath}
      component={(routeProps: any) => {
        return <LoaderRouteComponent {...routeProps} component={Component} />;
      }}
    />
  );
};
